import {BusinessEmailLayout} from "../components/layout/BusinessEmailLayout.js";
import {EmailInputView} from "./EmailInputView.js";
import {SignUpViewChanger} from "../util/view-changer/index.js";
import {Header} from "../components/Header.js";
import {EmailInput} from "../components/input/EmailInput.js";
import {getEmail, getPlanId} from "../store.js";
import {GoogleButton} from "../components/button/GoogleButton.js";
import SimpleComponent from "../components/SimpleComponent.js";


export class BusinessEmailView extends  EmailInputView {
    renderLayout() {
        const { mainText = '', subText = ''} = this.$props;
        this.$props.Layout = new BusinessEmailLayout(this.$target, {
            isAppend: true,
            sectionId : `emailInputSection`,
            mainText,
            subText,
            nextButton: {
                text: this.getNextButtonText(),
                nextPageFunc: this.moveEmailAuthView.bind(this)
            }
        });
    }
    renderComponents() {
        new Header(this.$props.Layout.getHeaderLayer(), {
            isShowLoginBtn: true,
            isShowPrevBtn: true
        });

        if (!Often.isGlobal()) {
            SimpleComponent.init({
                target: $('#mainTxt'),
                renderOption: 'before',
                template: () => {
                    return `<div class="extra-service-tooltip"><p>2025년에 가입한 모든 고객에게 <br>메일, 전자결재, 캘린더가 평생 무료!</p><img class="tooltip-arrow" src="/flow-renewal/assets/images/tooltip-arrow.png" alt=""></div>`
                }
            })
        }

        this.$props.EmailInput = new EmailInput(this.$props.Layout.getMainLayer(), {
            inputId: `emailInput`,
            $posTarget: $("#subTxt"),
            isAfter: true,
            isLast: true,
            emailValue : getEmail(),
            submit: this.moveEmailAuthView.bind(this),
        });

        this.renderGuestPageButton();

        const nextButton = $('.js-next-page-button')
        new GoogleButton(this.$props.Layout.getMainLayer(), {
            type : 'button',
            id: 'googleLoginButton',
            isAfter : true,
            $posTarget : nextButton
        })

        SimpleComponent.init({
            target: nextButton,
            renderOption: 'after',
            template: () => {
                return `<div class="guest-or"><span>${i18next.t(login.or)}</span></div>`
            }
        })
    }
    getNextButtonText() {
        return  i18next.t(login.startFreeTrial);
    }
    renderGuestPageButton() {
        const {guestPageButtonText = ''} = this.$props;
        if(Mutil.empty(window.CONNECT_INVITE_KEY) || Often.isGlobal()) {
            return
        }
        this.$props.Layout.getMainLayer().append(`<a class="js-move-guest-page-button btn-underline sign-bottom-link" href="#">${guestPageButtonText}</a>`)
    }

    setEvent() {
        super.setEvent();
        this.addEvent("click.stop.prevent", ".js-move-guest-page-button", () => {
            SignUpViewChanger.loadGuestEmailView();
        })
    }
}
